import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../core/guards/auth.guard';
import { GhostConsoleComponent } from './ghost-console.component';

const routes: Routes = [
  { path: 'ghost-console', component: GhostConsoleComponent, canActivate: [AuthGuard], data: { title: 'Ghost Console' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class GhostConsoleRoutingModule {}
